// Reconstructed from the supplied production build; original component names were unavailable.
import { React, jsxRuntime } from "../../vendor/runtime.js";
import { requestPasswordReset, resetPassword } from "../../api/passwordReset.js";
import { PasswordResetSuccess } from "./PasswordResetSuccess.jsx";
import { ResetInput } from "./ResetInput.jsx";
import { ResetOtpInput } from "./ResetOtpInput.jsx";
const ForgotPasswordForm = ({ onBack: a, onSuccess: n }) => {
  const [i, l] = React.useState(1),
    [c, u] = React.useState({
      email: "",
      otp: "",
      newPassword: "",
      confirmPassword: "",
    }),
    [m, f] = React.useState({}),
    [x, p] = React.useState(false),
    [g, b] = React.useState(null),
    [y, w] = React.useState(false),
    N = (B) => {
      (u({
        ...c,
        [B.target.name]: B.target.value,
      }),
        m[B.target.name] &&
          f({
            ...m,
            [B.target.name]: "",
          }),
        m.general &&
          f({
            ...m,
            general: "",
          }));
    },
    T = () => {
      const B = {};
      return (
        c.email
          ? /\S+@\S+\.\S+/.test(c.email) || (B.email = "Email is invalid")
          : (B.email = "Email is required"),
        f(B),
        Object.keys(B).length === 0
      );
    },
    C = () => {
      const B = {};
      return (
        c.otp
          ? c.otp.length !== 6 && (B.otp = "OTP must be 6 digits")
          : (B.otp = "OTP is required"),
        c.newPassword
          ? c.newPassword.length < 6 && (B.newPassword = "Password must be at least 6 characters")
          : (B.newPassword = "New password is required"),
        c.newPassword !== c.confirmPassword && (B.confirmPassword = "Passwords do not match"),
        f(B),
        Object.keys(B).length === 0
      );
    },
    A = async () => {
      if (T()) {
        (p(true), f({}));
        try {
          const B = await requestPasswordReset(c.email);
          B.success &&
            (b(B.userId),
            l(2),
            f({
              success: "OTP sent to your email address",
            }));
        } catch (B) {
          (console.error("Forgot password error:", B),
            f({
              general: B.message || "Failed to send OTP. Please check if the API endpoint exists.",
            }));
        } finally {
          p(false);
        }
      }
    },
    O = async () => {
      if (C()) {
        (p(true), f({}));
        try {
          (await resetPassword(g, c.otp, c.newPassword)).success && l(3);
        } catch (B) {
          (console.error("Reset password error:", B),
            f({
              general: B.message || "Password reset failed",
            }));
        } finally {
          p(false);
        }
      }
    },
    M = async () => {
      (w(true), f({}));
      try {
        (await requestPasswordReset(c.email)).success &&
          (f({
            success: "OTP resent to your email address",
          }),
          u((G) => ({
            ...G,
            otp: "",
          })));
      } catch (B) {
        f({
          general: B.message || "Failed to resend OTP",
        });
      } finally {
        w(false);
      }
    },
    Y = (B) => {
      const [G, te] = B.split("@");
      return `${G.length > 2 ? G.substring(0, 2) + "*".repeat(G.length - 2) : G}@${te}`;
    },
    R = () => (
      <svg className={"w-5 h-5"} fill={"none"} stroke={"currentColor"} viewBox={"0 0 24 24"}>
        <path
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"2"}
          d={
            "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
          }
        />
      </svg>
    ),
    U = () => (
      <svg className={"w-5 h-5"} fill={"none"} stroke={"currentColor"} viewBox={"0 0 24 24"}>
        <path
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"2"}
          d={
            "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          }
        />
      </svg>
    ),
    W = () => (
      <svg className={"w-5 h-5"} fill={"none"} stroke={"currentColor"} viewBox={"0 0 24 24"}>
        <path
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"2"}
          d={
            "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
          }
        />
      </svg>
    );
  return i === 3 ? (
    <PasswordResetSuccess onBackToLogin={a} />
  ) : (
    <div
      className={
        "bg-white rounded-2xl  lg:rounded-3xl shadow-2xl p-4 lg:p-8 w-full max-w-sm lg:max-w-md mx-auto animate-fadeInUp"
      }
    >
      <div className={"text-center mb-4 lg:mb-8"}>
        <div className={"flex items-center justify-center mb-4 lg:mb-6 relative"}>
          <button
            onClick={a}
            className={
              "absolute mb-12 sm:mb-20 left-0 p-2 text-blue-700 text-[12px] sm:text-[15px] hover:cursor-alias rounded-md hover:bg-gray-100 transition-colors duration-200"
            }
          >
            {"Back"}
          </button>
          <div className={"flex items-center justify-center"}>
            <img
              src={"/NavLogo.webp"}
              alt={"code bro , codebruh"}
              className={"h-20 w-20 lg:h-30 lg:w-30"}
              fetchPriority={"high"}
            />
          </div>
        </div>
        <h2 className={"text-sm lg:text-xl font-bold text-gray-800 mb-2 lg:mb-3"}>
          {i === 1 ? "Forgot Password" : "Reset Password"}
        </h2>
        <p className={"text-gray-600 text-[8px] lg:text-sm leading-relaxed"}>
          {i === 1
            ? "Enter your email address and we'll send you an OTP to reset your password."
            : `Enter the OTP sent to ${Y(c.email)} and create a new password.`}
        </p>
      </div>
      {m.general && (
        <div
          className={
            "bg-red-50 border border-red-200 text-red-700 px-3 py-2 lg:px-4 lg:py-3 rounded-lg lg:rounded-xl mb-4 lg:mb-6 animate-slideInLeft"
          }
        >
          <div className={"flex items-start"}>
            <svg
              className={"w-4 h-4 lg:w-5 lg:h-5 mr-2 mt-0.5 flex-shrink-0"}
              fill={"currentColor"}
              viewBox={"0 0 20 20"}
            >
              <path
                fillRule={"evenodd"}
                d={
                  "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                }
                clipRule={"evenodd"}
              />
            </svg>
            <span className={"text-xs lg:text-sm"}>{m.general}</span>
          </div>
        </div>
      )}
      {m.success && (
        <div
          className={
            "bg-green-50 border border-green-200 text-green-700 px-3 py-2 lg:px-4 lg:py-3 rounded-lg lg:rounded-xl mb-4 lg:mb-6 animate-slideInLeft"
          }
        >
          <div className={"flex items-start"}>
            <svg
              className={"w-4 h-4 lg:w-5 lg:h-5 mr-2 mt-0.5 flex-shrink-0"}
              fill={"currentColor"}
              viewBox={"0 0 20 20"}
            >
              <path
                fillRule={"evenodd"}
                d={
                  "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                }
                clipRule={"evenodd"}
              />
            </svg>
            <span className={"text-xs lg:text-sm"}>{m.success}</span>
          </div>
        </div>
      )}
      {i === 1 && (
        <div className={"space-y-4 lg:space-y-6"}>
          <ResetInput
            type={"email"}
            name={"email"}
            placeholder={"Email Address"}
            value={c.email}
            onChange={N}
            error={m.email}
            icon={<R />}
            className={"transform -translate-y-0"}
          />
          <button
            onClick={A}
            disabled={x}
            className={
              "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-2.5 lg:py-4 px-4 lg:px-6 rounded-lg lg:rounded-xl text-xs lg:text-base transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            }
          >
            {x ? (
              <div className={"flex items-center justify-center"}>
                <svg
                  className={"animate-spin -ml-1 mr-3 h-4 w-4 lg:h-5 lg:w-5 text-white"}
                  fill={"none"}
                  viewBox={"0 0 24 24"}
                >
                  <circle
                    className={"opacity-25"}
                    cx={"12"}
                    cy={"12"}
                    r={"10"}
                    stroke={"currentColor"}
                    strokeWidth={"4"}
                  />
                  <path
                    className={"opacity-75"}
                    fill={"currentColor"}
                    d={
                      "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    }
                  />
                </svg>
                {"Sending OTP..."}
              </div>
            ) : (
              "Send OTP"
            )}
          </button>
        </div>
      )}
      {i === 2 && (
        <div className={"space-y-4 lg:space-y-6"}>
          <ResetOtpInput length={6} value={c.otp} onChange={N} error={m.otp} />
          <ResetInput
            type={"password"}
            name={"newPassword"}
            placeholder={"New Password"}
            value={c.newPassword}
            onChange={N}
            error={m.newPassword}
            icon={<W />}
          />
          <ResetInput
            type={"password"}
            name={"confirmPassword"}
            placeholder={"Confirm New Password"}
            value={c.confirmPassword}
            onChange={N}
            error={m.confirmPassword}
            icon={<U />}
          />
          <button
            onClick={O}
            disabled={x}
            className={
              "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-2.5 lg:py-4 px-4 lg:px-6 rounded-lg lg:rounded-xl text-xs lg:text-base transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            }
          >
            {x ? (
              <div className={"flex items-center justify-center"}>
                <svg
                  className={"animate-spin -ml-1 mr-3 h-4 w-4 lg:h-5 lg:w-5 text-white"}
                  fill={"none"}
                  viewBox={"0 0 24 24"}
                >
                  <circle
                    className={"opacity-25"}
                    cx={"12"}
                    cy={"12"}
                    r={"10"}
                    stroke={"currentColor"}
                    strokeWidth={"4"}
                  />
                  <path
                    className={"opacity-75"}
                    fill={"currentColor"}
                    d={
                      "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    }
                  />
                </svg>
                {"Resetting Password..."}
              </div>
            ) : (
              "Reset Password"
            )}
          </button>
          <div className={"text-center pt-3 lg:pt-6 border-t border-gray-100"}>
            <p className={"text-xs lg:text-sm text-gray-600 mb-2 lg:mb-4"}>
              {"Didn't receive the code?"}
            </p>
            <button
              onClick={M}
              disabled={y}
              className={
                "inline-flex items-center justify-center px-3 lg:px-6 py-1.5 lg:py-3 border-2 border-indigo-200 text-indigo-600 rounded-lg lg:rounded-xl hover:border-indigo-300 hover:bg-indigo-50 transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none text-xs lg:text-base font-medium"
              }
            >
              {y ? (
                <jsxRuntime.Fragment>
                  <svg
                    className={"animate-spin -ml-1 mr-1.5 lg:mr-2 h-3 w-3 lg:h-4 lg:w-4"}
                    fill={"none"}
                    viewBox={"0 0 24 24"}
                  >
                    <circle
                      className={"opacity-25"}
                      cx={"12"}
                      cy={"12"}
                      r={"10"}
                      stroke={"currentColor"}
                      strokeWidth={"4"}
                    />
                    <path
                      className={"opacity-75"}
                      fill={"currentColor"}
                      d={
                        "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }
                    />
                  </svg>
                  {"Sending..."}
                </jsxRuntime.Fragment>
              ) : (
                <jsxRuntime.Fragment>
                  <svg
                    className={"w-3 h-3 lg:w-4 lg:h-4 mr-1.5 lg:mr-2"}
                    fill={"none"}
                    stroke={"currentColor"}
                    viewBox={"0 0 24 24"}
                  >
                    <path
                      strokeLinecap={"round"}
                      strokeLinejoin={"round"}
                      strokeWidth={"2"}
                      d={
                        "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      }
                    />
                  </svg>
                  {"Resend OTP"}
                </jsxRuntime.Fragment>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export { ForgotPasswordForm };
